import { PropsWithChildren } from "react";
import { AuthProvider } from "react-oidc-context"


export interface AuthenticatedProviderProps extends PropsWithChildren {
    authority: string
    client_id: string
    redirect_uri: string;
    scope?: string
}

export const AuthenticatedProvider = ({
    children,
    authority,
    client_id,
    redirect_uri,
    scope = "openid"
}: AuthenticatedProviderProps) => {
    const onSigninCallback = (_user: any) => {
        window.history.replaceState({}, document.title, window.location.pathname);
    };

    return (
        <AuthProvider
            authority={authority}
            client_id={client_id}
            redirect_uri={redirect_uri}
            onSigninCallback={onSigninCallback}
            scope={scope}
        >

            {children}

        </AuthProvider>
    );
};
